/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'remeda'
import { useCart } from './useCart'
import { useRecentProducts } from './useRecentProducts'
import { useRelatedProducts } from './useRelatedProducts'

export const useCartSuggestedProducts = () => {
  const { suggestedProductsHandle } = useCart()
  const { t } = useTranslation('product')

  const {
    data: complementaryProductsData,
    loading: complementaryProductsLoading,
    error: complementaryProductsError,
  } = useRelatedProducts({
    type: 'complementary',
    productHandle: suggestedProductsHandle,
  })

  const {
    recentProducts: recentProductsData,
    loading: recentProductsLoading,
    error: recentProductsError,
  } = useRecentProducts({
    skip:
      complementaryProductsLoading ||
      (complementaryProductsData && !isEmpty(complementaryProductsData)),
  })

  if (
    complementaryProductsData &&
    !isEmpty(complementaryProductsData) &&
    suggestedProductsHandle
  ) {
    return {
      data: complementaryProductsData,
      loading: complementaryProductsLoading,
      error: complementaryProductsError,
      onQuickAddEventName: 'complementary_quick_add',
      onAddToCartAddeventName: 'complementary_quick_add_to_cart',
      title: t('crossProductsTitle'),
      subtitle: t('crossProductsSubTitle'),
    }
  }

  if (!isEmpty(recentProductsData)) {
    return {
      data: recentProductsData,
      loading: recentProductsLoading,
      error: recentProductsError,
      onQuickAddEventName: 'recent_quick_add',
      onAddToCartAddEventName: 'recent_quick_add_to_cart',
      title: t('recentProductsTitle'),
      subtitle: t('recentProductsSubTitle'),
    }
  }

  return {
    data: [],
    error: null,
    loading: complementaryProductsLoading || recentProductsLoading,
  }
}
